/******/ (() => {
  // webpackBootstrap
  /******/ 'use strict';
  /******/ var __webpack_modules__ = {
    /***/ 669: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
      /* harmony export */ __webpack_require__.d(__webpack_exports__, {
        /* harmony export */ A: () => /* binding */ GlobalDrawer,
        /* harmony export */
      });
      class GlobalDrawer extends HTMLElement {
        constructor() {
          super();
          this.closeElements = this.querySelectorAll('[data-drawer-close]');
          this.openDrawer = this.openDrawer.bind(this);
          this.closeDrawer = this.closeDrawer.bind(this);
          this.closeAllDrawers = this.closeAllDrawers.bind(this);
          this.handleResize = this.handleResize.bind(this);
        }

        connectedCallback() {
          window.wetheme.webcomponentRegistry.register({
            key: 'component-drawer',
          });
          window.eventBus.on('close:all:drawers', this.closeAllDrawers);
          this.closeElements.forEach((element) => {
            element.addEventListener('click', this.closeDrawer);
          });

          if (window.Shopify.designMode) {
            window.addEventListener('resize', this.handleResize);
          }
        }

        openDrawer() {
          window.eventBus.emit('close:all:drawers', this); // Close all other global drawers before opening this one
          window.eventBus.emit('close:right:drawer'); // Close right drawer before opening
          this.setAttribute('aria-hidden', 'false');
          document.body.classList.add('js-drawer-open'); // Lock scroll
          this.addEventListener('transitionend', this.handleTransitionEnd);
        }

        closeDrawer() {
          this.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('js-drawer-open'); // Unlock scroll
          this.removeEventListener('transitionend', this.handleTransitionEnd);
        }

        closeAllDrawers(e) {
          if (e === this) return; // Only close other drawers not this one
          this.closeDrawer();
        }

        handleTransitionEnd(e) {
          // Trap focus once drawer is fully open
          if (e.target === this) {
            this.trapFocus();
          }
        }

        trapFocus() {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];
          firstFocusableElement.focus();
          this.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
              if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                  lastFocusableElement.focus();
                  e.preventDefault();
                }
              } else {
                if (document.activeElement === lastFocusableElement) {
                  firstFocusableElement.focus();
                  e.preventDefault();
                }
              }
            }
          });
        }

        handleResize() {
          this.classList.add('disable-transitions');
          setTimeout(() => {
            this.classList.remove('disable-transitions');
          }, 500);
        }

        disconnectedCallback() {
          if (window.Shopify.designMode) {
            window.removeEventListener('resize', this.handleResize);
          }
        }
      }

      /***/
    },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key],
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  /* harmony import */ var _global_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(669);

  class Component {
    /**
     * Generic component, inherited class will be called to receive things like resize events.
     *
     * @param {import('./ThemeBase').default} theme
     * @param {HTMLElement} element
     */
    constructor(theme, element) {
      this.theme = theme;
      this.element = element;
      theme.registerComponent(this);
    }

    /**
     * This will be called immediatelly when window resizes.
     *
     * NOTE: prefer using onWindowResize as it's already debounced.
     *
     * @param {Object} params
     * @param {number} params.width Width of the window
     */
    onWindowResizeRaw = ({ width }) => {};

    /**
     * This will be called regularly (throttled) when window is being resized.
     *
     * @param {Object} params
     * @param {number} params.width New width of the window
     * @param {number} params.oldWidth Width of the window last time this was called
     * @param {import("./constants").Breakpoint} params.breakpoint Current width breakpoint
     */
    onWindowResize = ({ width, oldWidth, breakpoint }) => {};

    /**
     * This will be called when window is being resized and it changes current breakpoint.
     *
     * @param {Object} params
     * @param {number} params.width New width of the window
     * @param {import("./constants").Breakpoint} params.breakpoint Current width breakpoint
     * @param {import("./constants").Breakpoint} params.oldBreakpoint Breakpoint last time this was called
     */
    onWindowResizeBreakpoint = ({ width, breakpoint, oldBreakpoint }) => {};

    /**
     * This will be called regularly (throttled) when window is scrolled
     */
    onWindowScroll = () => {};
  }

  class QuickAdd extends Component {
    constructor(theme, element) {
      super(theme, element);
      this.theme = theme;
      this.element = element;
      this.onSubmit = this.onSubmit.bind(this);
      this.currentButton = null;
      this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
      this.cartType = document.getElementById('PageContainer').dataset.cartType;
      this.languageUrl = document.getElementById('PageContainer').dataset.languageUrl;
      this.formWrapper = /** @type {HTMLElement} */ this.element.querySelectorAll('.quick-add-wrapper.is-singular');
      this.wethemeGlobal = document.querySelector('script#wetheme-global');
      this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);
      if (!this.formWrapper) {
        return;
      }
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.quick-add-wrapper.is-singular .shopify-product-form'),
        (el) => {
          el.addEventListener('submit', this.onSubmit);
        },
      );
    }
    async onSubmit(e) {
      // Go straight to cart page, use html form submit event.
      if (this.cartType == 'page' && this.cartAction != 'show_added_message') {
        return;
      }
      e.preventDefault();
      this.currentButton = e.currentTarget.querySelector('.quick-add-button');
      this.isDesktopQuickAdd = this.currentButton.classList.contains('quick-add-button-desktop');

      // Loading spinner.
      if (this.isDesktopQuickAdd)
        this.currentButton.innerHTML = `<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" class="spin flex-full"><g clip-path="url(#clip0_3605_47041)"><path d="M12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 15.1767 22.1534 18.0388 20 20.0468" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></g><defs><clipPath id="clip0_3605_47041"><rect width="24" height="24" fill="none" transform="translate(0.5)"/></clipPath></defs>${this.translationsObject.translations.loading}</svg>`;
      try {
        const formData = new FormData(e.currentTarget);
        const data = new URLSearchParams(formData).toString();

        const response = await window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: data,
        });
        if (!response.ok) {
          // FIXME: error handling
          return false;
        }

        // Update cart drawer
        if (this.cartType == 'drawer') {
          const responseJson = await response.json();
          window.eventBus.emit('update:cart:drawer', responseJson);
        }
        const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
        const response2 = await window.fetch(`${languageParam}/cart?view=compare`);
        if (!response2.ok) {
          // FIXME: error handling
          return false;
        }
        const cart = await response2.json();
        if (this.cartType == 'drawer' && this.cartAction == 'go_to_or_open_cart') {
          window.eventBus.emit('open:cart:drawer', {
            scrollToTop: true,
          });
        } else {
          if (this.isDesktopQuickAdd) this.currentButton.innerHTML = this.translationsObject.translations.productAdded;
        }
        this.theme.updateCartCount(cart);
        if (this.isDesktopQuickAdd) {
          setTimeout(() => {
            this.currentButton.innerHTML = this.translationsObject.translations.addToCart;
          }, 2000);
        }
      } catch (e) {
        console.error('Unable to add to cart: ', e);
        // FIXME error handling
      }
      return false;
    }
  }

  class CartDrawer extends _global_drawer__WEBPACK_IMPORTED_MODULE_0__ /* ["default"] */.A {
    constructor() {
      super();
      this.dynamicContentIds = ['cart-header', 'cart-body', 'cart-footer', 'cart-gamification'];
      this.scrollElement = this.querySelector('[data-cart-scroll-element]');
      this.handleCartOpen = this.handleCartOpen.bind(this);
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handleCartRender = this.handleCartRender.bind(this);
    }

    connectedCallback() {
      super.connectedCallback();
      window.wetheme.webcomponentRegistry.register({
        key: 'component-cart-drawer',
      });

      this.init();

      window.eventBus.on('open:cart:drawer', this.handleCartOpen);
      window.eventBus.on('update:cart:drawer', this.handleCartUpdate);
      window.eventBus.on('render:cart:drawer', this.handleCartRender);
    }

    init() {
      this.handleShopNow = (e) => {
        e.preventDefault();
        window.wetheme.toggleRightDrawer('shop-now', true, {
          url: e.currentTarget.href,
        });
      };

      // Ouvrir le cart drawer si l'URL contient open_cart=true
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('open_cart') === 'true') {
        this.handleCartOpen({ scrollToTop: true });
      }
    }

    handleCartOpen(e) {
      /* ===== Scroll to top of the cart if necessary ===== */
      if (e?.scrollToTop && this.scrollElement) {
        this.scrollElement.scrollTo(0, 0);
      }

      /* ===== Open the drawer ===== */
      this.openDrawer();
    }

    handleCartUpdate(e) {
      if (!e) return;
      if (e.sections?.['cart-drawer']) {
        this.renderCartDrawer(e.sections['cart-drawer']);
      }
    }

    renderCartDrawer(html) {
      /* ===== Re-render cart drawer with updated content ===== */
      this.dynamicContentIds.forEach((id) => {
        const selector = `[data-cart-dynamic-content="${id}"]`;
        const updatedContent = this.getContent(html, selector);
        const targetElement = this.querySelector(selector);
        if (targetElement) {
          targetElement.innerHTML = updatedContent;

          this.init();
        }
      });
      this.trapFocus();
    }

    async handleCartRender() {
      /* ===== Fetch cart drawer using section rendering API (rather than bundled section rendering) - needed when adding more products to the cart than are in stock ===== */
      try {
        const response = await fetch(window.Shopify.routes.root + '?sections=cart-drawer');
        const responseJson = await response.json();
        if (responseJson?.['cart-drawer']) {
          this.renderCartDrawer(responseJson['cart-drawer']);
        }
      } catch (error) {
        console.error(`Failed to fetch cart drawer:`, error);
      }
    }

    getContent(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
  /******/
})();
